import React from 'react';
import Hero from '../components/Hero';
import TrialHero from '../components/TrialHero';
import Features from '../components/Features';
import WebinarRegistration from '../components/WebinarRegistration';
import Pricing from '../components/Pricing';
import TrialCTA from '../components/TrialCTA';
import CTASection from '../components/CTASection';
import StickyCTA from '../components/StickyCTA';
import { SEOHead, organizationSchema, websiteSchema, softwareSchema } from '../components/SEOHead';

const HomePage = () => {
  const homeSchema = [organizationSchema, websiteSchema, softwareSchema];

  return (
    <>
      <SEOHead 
        title="Školobot | AI pro české pedagogy"
        description="Komplexní AI platforma pro české pedagogy. 100+ šablon pro přípravy na hodiny, testy, IVP a další materiály v souladu s RVP. Vyzkoušejte zdarma."
        path="/"
        schema={homeSchema}
      />
      <Hero />
      <TrialHero />
      <Features />
      <WebinarRegistration />
      <Pricing />
      <TrialCTA />
      <CTASection />
      <StickyCTA />
    </>
  );
};

export default HomePage;
